import { useAuthContext } from '@aibees/shared/auth';
import { Icon, TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ChangeEmailProps as Props } from './types';

export const ChangeEmail = memo(({ className }: Props) => {
  const { user } = useAuthContext();

  return (
    <Styled.Wrapper
      className={classnames('ChangeEmail', className)}
      sx={SX.root}
    >
      <Stack gap={0.5}>
        <Stack direction="row" gap={0.5} alignItems="center">
          <Icon name="email" size={20} color="grey.600" />
          <Typography variant="body4" fontWeight={500} color="grey.600">
            Email Address
          </Typography>
        </Stack>
        <TextEllipsis variant="body3" fontWeight={700}>
          {user?.email}
        </TextEllipsis>
      </Stack>
    </Styled.Wrapper>
  );
});

ChangeEmail.displayName = 'ChangeEmail';
